<template>
    <glm-layout margin-footer>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h1 class="font-bold font-serif text-3xl">
                        Variable Description
                    </h1>
                </div>
            </div>
        </world-map>

        <page-content class="mt-12">
            <div class="flex items-center mb-6 mt-10 sm:mt-0 px-4 sm:px-0">
                <div class="ml-auto">
                    <Input
                        id="search"
                        type="text"
                        placeholder="Search..."
                        class="block w-full"
                        v-model="varSearch"
                    />
                </div>
            </div>

            <template v-for="(variableCategory, idx) in varSearchResults">
                <template v-if="variableCategory.options.length > 0">
                    <h2 class="font-semibold mb-6 text-glm-blue text-3xl font-serif" :class="{'mt-12' : idx > 0}">
                        {{ variableCategory.label }}
                    </h2>

                    <table
                        class="w-full sm:rounded-md bg-white divide-y divide-gray-300 overflow-hidden shadow">
                        <thead class="bg-gray-900">
                        <tr class="text-white">
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-left sm:w-64">Variable</th>
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-left sm:w-64">
                                Definition
                            </th>
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-left sm:w-64">DHS
                                implementation
                            </th>
                            <th class="font-semibold text-sm uppercase px-6 py-4 text-left sm:w-64">IPUMS
                                implementation
                            </th>
                        </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-200">
                        <tr v-for="(variable, idx) in variableCategory.options" :key="idx"
                            :class="{'bg-gray-100' : idx % 2 !== 0}">
                            <td class="px-6 py-4 sm:w-64">
                                {{ variable.value }}
                            </td>

                            <td class="px-6 py-4 sm:w-64">
                                {{ variable.definition }}
                            </td>

                            <td class="px-6 py-4 sm:w-64">
                                {{ variable.dhs }}
                            </td>

                            <td class="px-6 py-4 sm:w-64">
                                {{ variable.ipums }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </template>
            </template>
        </page-content>
    </glm-layout>
</template>

<script>
import NavBar from '@/Components/NavBar'
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'
import PageContent from '@/Components/PageContent'
import Member from '@/Components/Member'
import Input from "@/Jetstream/Input.vue";

export default {
    components: {
        Input,
        Member,
        PageContent,
        WorldMap,
        GlmLayout,
        NavBar,
    },

    props: ['varOptions'],

    data() {
        return {
            varSearch: null,
        }
    },

    computed: {
        varSearchResults() {
            if (!this.varSearch) return this.varOptions

            return this.varOptions.map((variableCategory) => {
                return {
                    ...variableCategory,
                    options: variableCategory.options.filter((variable) => {
                        return variable.value.toLowerCase().includes(this.varSearch.toLowerCase())
                    }),
                }
            })
        },
    },
}
</script>
